"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCurrentPage = exports.leftLastPage = exports.moveNextPage = exports.pageSwitched = exports.clickPreviousPage = exports.clickNextPage = void 0;
const clickNextPage = () => {
    return {
        type: 'CLICK_NEXT_PAGE'
    };
};
exports.clickNextPage = clickNextPage;
const clickPreviousPage = () => {
    return {
        type: 'CLICK_PREVIOUS_PAGE'
    };
};
exports.clickPreviousPage = clickPreviousPage;
const pageSwitched = (pageNumber) => {
    return {
        type: 'PAGE_SWITCHED',
        data: { pageNumber }
    };
};
exports.pageSwitched = pageSwitched;
const moveNextPage = ({ from, to }) => {
    return {
        type: 'MOVE_NEXT_PAGE',
        to,
        from
    };
};
exports.moveNextPage = moveNextPage;
const leftLastPage = () => {
    return {
        type: 'LEFT_LAST_PAGE'
    };
};
exports.leftLastPage = leftLastPage;
const setCurrentPage = (pageNumber) => {
    return {
        type: 'SET_CURRENT_PAGE',
        data: { pageNumber }
    };
};
exports.setCurrentPage = setCurrentPage;
